<div #form>
    
</div>
<kendo-excelexport  [fileName]="excelName+'.xlsx'" [forceProxy]="true" proxyURL="/api/fileProxy" #excelexport>
    <kendo-excelexport-column *ngFor="let column of columnSettings;" [field]="column.fieldName"
                              [title]="column.display" [width]="column.width">
    </kendo-excelexport-column>
</kendo-excelexport>

